import React from 'react';
import './Home.css';
import HeroSection from './HeroSection';
import About from './About';
import Skills from './Skills';
import Projects from './Projects';
import Contact from './Contact';
import { HashLink as Link } from 'react-router-hash-link';
import ThirdProject from './ThirdProject';
import CaseStudy from './CaseStudy';
import Footer from './Footer';





const Home = () => {

    return (

        <div className='background'>
            <HeroSection></HeroSection>
            <About></About>
            <Skills></Skills>
            <Projects></Projects>
            <ThirdProject></ThirdProject>
            <CaseStudy></CaseStudy>
            <Contact></Contact>
            <Footer></Footer>
     </div>
    );
};

export default Home;